import { render, staticRenderFns } from "./Enterpriseinfo.vue?vue&type=template&id=27615022&scoped=true"
import script from "./Enterpriseinfo.vue?vue&type=script&lang=js"
export * from "./Enterpriseinfo.vue?vue&type=script&lang=js"
import style0 from "./Enterpriseinfo.vue?vue&type=style&index=0&id=27615022&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27615022",
  null
  
)

export default component.exports